import React from 'react'
import { useField } from 'formik'
import NumberFormat from 'react-number-format'

function NeoPassword({
  value,
  placeholder,
  maxLength = '',
  minLength = '',
  className,
  onChange,
  disabled,
  tabIndex,
  ...props 

}) {
  const [field] = useField(props)
  return (
    <NumberFormat
      allowLeadingZeros={true}
      maxLength={maxLength}
      minLength={minLength}
      placeholder={placeholder}
      allowNegative={false}
      className={className}
      displayType={'input'}
      type="password"
      thousandSeparator={false}
      isNumericString
      onValueChange={onChange}
      disabled={disabled}
      {...field}
      tabIndex={tabIndex}
    />
  )
}

export default React.memo(NeoPassword)
